/**
 * Пак «Чайханский» — фоны и шаги `state_desktop_*` / `state_mobile_*` в `packs/chayhanskiy/`.
 */
import chayhanskiyBgDesktop from '@/assets/img/rice-game/packs/chayhanskiy/bg-desktop.jpg';
import chayhanskiyBgDesktop2x from '@/assets/img/rice-game/packs/chayhanskiy/bg-desktop@2x.jpg';
import chayhanskiyBgMobile from '@/assets/img/rice-game/packs/chayhanskiy/bg-mobile.jpg';
import chayhanskiyBgMobile2x from '@/assets/img/rice-game/packs/chayhanskiy/bg-mobile@2x.jpg';

import chayhanskiyStateD01 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_1.png';
import chayhanskiyStateD02 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_2.png';
import chayhanskiyStateD03 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_3.png';
import chayhanskiyStateD04 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_4.png';
import chayhanskiyStateD05 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_5.png';
import chayhanskiyStateD06 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_6.png';
import chayhanskiyStateD07 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_7.png';
import chayhanskiyStateD08 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_8.png';
import chayhanskiyStateD09 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_9.png';
import chayhanskiyStateD10 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_10.png';
import chayhanskiyStateD11 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_11.png';
import chayhanskiyStateD12 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_12.png';
import chayhanskiyStateD13 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_13.png';
import chayhanskiyStateD14 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_14.png';
import chayhanskiyStateD15 from '@/assets/img/rice-game/packs/chayhanskiy/state_desktop_15.png';

import chayhanskiyStateM01 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_1.png';
import chayhanskiyStateM02 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_2.png';
import chayhanskiyStateM03 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_3.png';
import chayhanskiyStateM04 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_4.png';
import chayhanskiyStateM05 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_5.png';
import chayhanskiyStateM06 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_6.png';
import chayhanskiyStateM07 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_7.png';
import chayhanskiyStateM08 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_8.png';
import chayhanskiyStateM09 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_9.png';
import chayhanskiyStateM10 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_10.png';
import chayhanskiyStateM11 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_11.png';
import chayhanskiyStateM12 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_12.png';
import chayhanskiyStateM13 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_13.png';
import chayhanskiyStateM14 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_14.png';
import chayhanskiyStateM15 from '@/assets/img/rice-game/packs/chayhanskiy/state_mobile_15.png';

export const chayhanskiyBackgrounds = {
  backgroundDesktop: chayhanskiyBgDesktop,
  backgroundDesktop2x: chayhanskiyBgDesktop2x,
  backgroundMobile: chayhanskiyBgMobile,
  backgroundMobile2x: chayhanskiyBgMobile2x,
};

export const chayhanskiyFramesDesktop = [
  chayhanskiyStateD01,
  chayhanskiyStateD02,
  chayhanskiyStateD03,
  chayhanskiyStateD04,
  chayhanskiyStateD05,
  chayhanskiyStateD06,
  chayhanskiyStateD07,
  chayhanskiyStateD08,
  chayhanskiyStateD09,
  chayhanskiyStateD10,
  chayhanskiyStateD11,
  chayhanskiyStateD12,
  chayhanskiyStateD13,
  chayhanskiyStateD14,
  chayhanskiyStateD15,
];

export const chayhanskiyFramesMobile = [
  chayhanskiyStateM01,
  chayhanskiyStateM02,
  chayhanskiyStateM03,
  chayhanskiyStateM04,
  chayhanskiyStateM05,
  chayhanskiyStateM06,
  chayhanskiyStateM07,
  chayhanskiyStateM08,
  chayhanskiyStateM09,
  chayhanskiyStateM10,
  chayhanskiyStateM11,
  chayhanskiyStateM12,
  chayhanskiyStateM13,
  chayhanskiyStateM14,
  chayhanskiyStateM15,
];
